import React from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { AppBar, Grid, Container, CardMedia, Card, Button, Typography, Box, Link, Divider, CardContent, Paper } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { setContactUs } from 'api/session';

const classes = {
    root: {
        backgroundColor: "#fff",
        minHeight: "180px",
        position: "relative",
        marginTop: "50px",
        color: "#fff"
    },
    footer: {
        backgroundColor: "#fff",
        display: {
            xs: 'none',
            md: 'block'
        },
        paddingBottom: "5px",
    },

    pl10: {
        paddingLeft: "10px"
    },
};

const Footer = (props) => {
    const navi = useNavigate();
    const dispatch = useDispatch();
    const footer = useSelector(state => state.session.footer);
    const xsSize = useMediaQuery((theme) => theme.breakpoints.only('xs'));
    const smSize = useMediaQuery((theme) => theme.breakpoints.only('sm'));
    const mdSize = useMediaQuery((theme) => theme.breakpoints.only('md'));
    const lgSize = useMediaQuery((theme) => theme.breakpoints.only('lg'));
    const xlSize = useMediaQuery((theme) => theme.breakpoints.only('xl'));
    return (
        <AppBar position="static" sx={classes.root} elevation={0}>
            <Divider sx={{ margin: "10px" }} />
            <Container direction={"column"} disableGutters maxWidth={"xl"} sx={{ marginBottom: "50px" }}>

                <Grid container direction={"row"} justifyContent="center">
                    <Card elevation={0} sx={{ width: "600px" }}>
                        <Grid container item xs={12} justifyContent={'center'}>
                            {
                                xsSize ? <CardMedia
                                    image={'/tirefax.png'}
                                    sx={{
                                        width: "350px",
                                        height: "150px",
                                    }}
                                    width={350}
                                    height={150}
                                    alt="logo"
                                /> : smSize ? <CardMedia
                                    image={'/tirefax.png'}
                                    sx={{
                                        width: "480px",
                                        height: "228px"
                                    }}
                                    width={480}
                                    height={228}
                                    alt="logo"
                                /> : mdSize ? <CardMedia
                                    image={'/tirefax.png'}
                                    sx={{
                                        width: "480px",
                                        height: "228px"
                                    }}
                                    width={480}
                                    height={228}
                                    alt="logo"
                                /> : lgSize ? <CardMedia
                                    image={'/tirefax.png'}
                                    sx={{
                                        width: "480px",
                                        height: "228px"
                                    }}
                                    width={480}
                                    height={228}
                                    alt="logo"
                                /> : xlSize ? <CardMedia
                                    image={'/tirefax.png'}
                                    sx={{
                                        width: "480px",
                                        height: "228px"
                                    }}
                                    width={480}
                                    height={228}
                                    alt="logo"
                                /> : ''
                            }
                            <CardContent>
                                <Typography sx={{ fontSize: "16px", fontWeight: "400", marginTop: "20px" }} align='justify'><Link href="/privacy">Privacy Notice</Link> and <Link href="/terms">Terms of Use</Link>.</Typography>
                            </CardContent>
                        </Grid>

                    </Card>
                    <Grid item md={1} display={{ xs: "none", md: "flex" }}>
                        <Divider orientation='vertical' sx={{ marginX: "20px" }} />
                    </Grid>
                    <Card elevation={0}>
                        <Button
                            onClick={() => navi.push('/')} size="large"
                            edge="start" color="inherit" aria-label="menu"
                            fullWidth
                            sx={{
                                mr: 2,
                                display: { xs: 'none', md: 'flex' },
                                padding: "0px"
                            }}
                        >
                            <CardMedia
                                image={'/tirefax.png'}
                                sx={{
                                    width: "160px",
                                    height: "76px"
                                }}
                                width={160}
                                height={76}
                                alt="logo"
                            />
                        </Button>
                        {/* <CardContent>
                            <Typography variant="h6" component="div" align='left'>DEALERS: dealers@tirefax.com</Typography>
                            <Typography variant="h6" component="div" align='left'>AUTO SERVICES: autos@tirefax.com</Typography>
                            <Typography variant="h6" component="div" align='left'>FLEETS: fleets@tirefax.com</Typography>

                        </CardContent> */}
                        <Paper sx={{ border: "1px solid #1976d2", padding: "10px", }}>
                            <Typography variant="H5" component="div" align='center'>dealers@tirefax.com</Typography>
                        </Paper>
                        <Paper sx={{ border: "1px solid #1976d2", padding: "10px", marginTop: "10px" }}>
                            <Typography variant="H5" component="div" align='center'>autos@tirefax.com</Typography>
                        </Paper>
                        <Paper sx={{ border: "1px solid #1976d2", padding: "10px", marginTop: "10px" }}>
                            <Typography variant="H5" component="div" align='center'>fleets@tirefax.com</Typography>
                        </Paper>
                        <Paper sx={{ border: "1px solid #1976d2", padding: "10px", marginTop: "20px" }}>
                            <Typography variant="H5" component="div" align='center'>1-855-TIREFAX</Typography>
                        </Paper>
                        <Button fullWidth variant='contained' color='warning' sx={{ marginTop: "20px" }}
                            onClick={() => dispatch(setContactUs(true))}
                        >Create Account</Button>

                        <Button fullWidth variant='contained' color='warning' sx={{ marginTop: "20px" }}
                            onClick={() => dispatch(setContactUs(true))}
                        >Contact Us</Button>

                        {/* <Typography variant="body2" component="div" sx={{
                            paddingLeft: "10px",
                            paddingTop: "10px",

                        }} >Follow Us</Typography> */}
                        <Box justifyContent="flex-start"
                            sx={{
                                display: {
                                    xs: "none",
                                    md: "flex"
                                }
                            }}
                        >
                        </Box>
                    </Card>
                    <Grid container item md={3} display="flex" direction="column" justifyContent="space-between"
                        sx={{
                            paddingLeft: "10px",
                            paddingTop: "10px",
                            color: "#000"
                        }} >


                    </Grid>

                </Grid>
            </Container>
            <Divider sx={{ margin: "10px" }} />
            <Container direction={"row"} disableGutters maxWidth="lg" sx={{ marginBottom: "10px" }}>
                <Grid container item md={12} display="flex" direction={'column'}
                    sx={{
                        paddingLeft: "10px",
                        paddingTop: "10px",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "#000"
                    }} >
                    <Typography variant="body2" sx={{ fontSize: "10px" }} align='center'>Copyright © 2025 All Rights Reserved. Tirefax is a registered trademark</Typography>

                </Grid>
            </Container>
        </AppBar >
    )
}

export default Footer;